import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import { colors } from '../../../const/color';
import IconNonFilledStyled from '../icon-non-fill.styled';

const IconDataPrivacy: FC<IconProps> = ({ $size, ...rest }) => {
  return (
    <IconNonFilledStyled {...{ $size, ...rest }}>
      <svg width="100%" height="100%" viewBox={`0 0 32 32`} fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="16" cy="16" r="16" />
        <path
          d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
          stroke={colors[rest?.$color]}
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M16 10V17"
          stroke={colors[rest?.$color]}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fill={colors[rest?.$color]}
          d="M16 23C16.8284 23 17.5 22.3284 17.5 21.5C17.5 20.6716 16.8284 20 16 20C15.1716 20 14.5 20.6716 14.5 21.5C14.5 22.3284 15.1716 23 16 23Z"
        />
      </svg>
    </IconNonFilledStyled>
  );
};

IconDataPrivacy.defaultProps = iconDefaultProps;
IconDataPrivacy.displayName = 'IconDataPrivacy';

export default IconDataPrivacy;
